import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import TweenMax from 'TweenMax';

import Logo from './Logo';
import Container from './Container';
import { clearfix, linkChangeColor, toVw } from '../utils/styles';
import { EMAIL_CONTACT, FONT_SIZE_TEXT } from '../constants';
import StyledLink from './StyledLink';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  position: absolute;
  left: 0;
  bottom: ${toVw(36)};
  width: 100%;
  z-index: 1;
  ${clearfix};
`;

const RelativeContainer = styled(Container)`
  position: relative;
`;

const LogoStyled = styled(Logo)`
  position: absolute;
  left: 0;
  bottom: 0;

  ${mq.mobile375(css`
    width: 28px;
  `)};
`;

const Email = styled(StyledLink)`
  position: absolute;
  text-decoration: none;
  right: 0;
  bottom: 5px;
  font-size: ${FONT_SIZE_TEXT}px;

  a {
    ${props => linkChangeColor(props.bright === 'true' ? props.theme.colorBright : props.theme.colorText)};
  }

  ${mq.mobile375(css`
    font-size: 16px;
  `)};
`;

class Footer extends React.Component {
  static propTypes = {
    bright: PropTypes.bool,
    inScene: PropTypes.bool,
    fadedOut: PropTypes.bool,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.fadedOut !== this.props.fadedOut) {
      nextProps.fadedOut
        ? TweenMax.to(this.containerNode, 0.35, { autoAlpha: 0 })
        : TweenMax.to(this.containerNode, 0.35, { autoAlpha: 1 });
    }
  }

  render() {
    const { bright } = this.props;

    return (
      <Styled innerRef={node => (this.containerNode = node)}>
        <RelativeContainer>
          <LogoStyled bright={bright} />
          <Email bright={bright ? bright.toString() : ''} href={`mailto:${EMAIL_CONTACT}`} color="#fff">
            {EMAIL_CONTACT}
          </Email>
        </RelativeContainer>
      </Styled>
    );
  }
}

export default inject(stores => ({
  themeStore: stores.store.theme,
  UIStore: stores.store.UIStore,
}))(observer(({ UIStore, ...rest }) => <Footer {...rest} fadedOut={UIStore.footerFadedOut} />));



// WEBPACK FOOTER //
// ./src/components/Footer.js